export const availableLanguages = ['uk', 'ru', 'en'];
